import queryString from 'query-string';
import http from '.';
import { apiUsers, apiImportUser, apiUserCourses } from './apiRouter';

const getListMember = (body, axiosConfig = {}) => {
  const params = queryString.stringify(body);
  return http.get(`${apiUsers}?${params}`, axiosConfig);
};

const getDetailMember = (id) => {
  return http.get(`${apiUsers}/${id}`);
};

const deleteMember = (body) => http.delete(apiUsers, { data: body });
const createMember = (body) => http.post(apiUsers, body);
const importMember = (body) =>
  http.post(apiImportUser, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

const getCourse = () => http.get(apiUserCourses);

const updateMember = (params, bodyData) => {
  return http.patch(`${apiUsers}/${params}`, bodyData);
};

const changeStatusUser = (id, bodyData) => {
  return http.patch(`${apiUsers}/${id}/status`, bodyData);
};

const MemberService = {
  getListMember,
  deleteMember,
  getDetailMember,
  createMember,
  updateMember,
  importMember,
  getCourse,
  changeStatusUser,
};

export default MemberService;
